import type { ReactNode } from "react";
import type { Role } from "../../../shared/types";
import "./operations.css";

const RANK: Record<Role, number> = {
  volunteer: 1,
  member: 2,
  coordinator: 3,
  leader: 4,
  owner: 5,
};

export function hasRole(role: Role | undefined, minimum: Role): boolean {
  if (!role) return false;
  return RANK[role] >= RANK[minimum];
}

export function messageOf(caught: unknown): string {
  return caught instanceof Error ? caught.message : "Something went wrong";
}

export function slugify(value: string): string {
  return value.toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60);
}

export function PageFrame({ kicker, title, lede, actions, className, children }: {
  kicker: string;
  title: string;
  lede?: string;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={className ? `page ${className}` : "page"}>
      <header className="page-head">
        <div>
          <p className="kicker">{kicker}</p>
          <h1 className="page-title">{title}</h1>
          {lede ? <p className="lede">{lede}</p> : null}
        </div>
        {actions ? <div className="cluster">{actions}</div> : null}
      </header>
      {children}
    </section>
  );
}

export function CapacityMeter({ confirmed, remaining, capacity }: { confirmed: number; remaining: number; capacity: number }) {
  const width = capacity > 0 ? Math.min(100, Math.round((confirmed / capacity) * 100)) : 0;
  return (
    <div className="stack">
      <div className="split">
        <span>{confirmed} confirmed</span>
        <span className="faint">{remaining} left of {capacity}</span>
      </div>
      <div className="meter" role="meter" aria-valuemin={0} aria-valuemax={capacity} aria-valuenow={confirmed} aria-label={`${remaining} places left`}>
        <span style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}
